export default {
  title: 'Kliknij lub przeciągnij plik tutaj, aby przesłać',
  description: 'Obsługiwane formaty: .csv, .xls, .xlsx',
  buttons: {
    download_template: 'Pobierz szablon importu',
  },
  toasts: {
    error: 'Nie udało się przesłać pliku',
  },
};
